import GroupManageEmailSettings from "discourse/components/group-manage-email-settings";

export default <template>
  <GroupManageEmailSettings @group={{@controller.model}} />
</template>
